import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { ApiResponse } from 'src/app/shared/interfaces/api-response';
import { StrikeDetail } from "src/app/shared/interfaces/strike-details";
import { StrikeHouse, StrikeHouses } from "src/app/shared/interfaces/strike-houses";
import {StrikePicketLine} from "src/app/shared/interfaces/strike-picketlines";

import { ModalService } from '../../../core/modal.service';
import { NotificationService } from '../../../core/notification.service';
import { StrikeService } from '../../../core/strike.service';

@Component({
  selector: 'app-add-picketline-modal',
  templateUrl: './add-picketline-modal.component.html',
  styleUrls: ['./add-picketline-modal.component.css']
})
export class AddPicketlineModalComponent implements OnInit {
  strike: StrikeDetail = {
    weekNumber: 0,
    dayNumber: 0,
  };
  selectedHouse: StrikeHouse = {
    StrikeInfoId: 0,
    HouseId: "",
    HouseName: "",
    NoOfEmployees: 0,
  };
  allHouses: StrikeHouses = [];
  disableButton = false;

  constructor(private notificationService: NotificationService, private modal: ModalService, private strikes: StrikeService) { }

  addPicketlineForm = new FormGroup({
    strikeHouseId: new FormControl('', {validators: Validators.required, nonNullable: true}),
    picketlineName: new FormControl('', {validators: Validators.required, nonNullable: true}),
    description: new FormControl('', {validators: Validators.required, nonNullable: true}),
  })

  get picketlineName() { return this.addPicketlineForm.get('picketlineName'); }
  get strikeHouseId() { return this.addPicketlineForm.get('strikeHouseId'); }


  ngOnInit() {
    if (this.strike.ID) {
      this.loadStrikeHouses(this.strike.ID)
    }
  }

  async loadStrikeHouses(id: string | number) {
    this.notificationService.displayInfo('Loading available strike houses for ' + this.strike.Title)
    const response: StrikeHouses = await this.strikes.getStrikeHouses(id);

    if (response.length) {
      this.allHouses = response;
      this.selectedHouse = this.allHouses[0];
    }
    else {
      this.notificationService.displayError('There was an error loading houses')
    }
  }

  async addPicketline() {
    const newPicketline : StrikePicketLine = {
    StrikeInfoId: Number(this.strike.ID),
    StrikeHouseId: this.addPicketlineForm.getRawValue().strikeHouseId,
    PicketLineName: this.addPicketlineForm.getRawValue().picketlineName,
    Descr: this.addPicketlineForm.getRawValue().description,
    }

    this.notificationService.displayInfo('Adding Picketline')
    this.disableButton = true;
    const response: ApiResponse = await this.strikes.addPicketline(newPicketline)

    if (response.success) {
    this.notificationService.displaySuccess('Picketline was successfully added')
    }
    else {
    this.notificationService.displayError('Error adding picketline')
    }

    this.disableButton = false;
    this.modal.submitClicked.next(true)
    this.modal.closeModal()
  }

  closeModal() {
    this.modal.closeModal();
  }
}
